<div class="contains">
   <div><img src="/assets/2022/imgs/lookguide/navi_pic3@2x.png" alt="" width="720px" height="428px"></div>
   <img src="/assets/2022/imgs/lookguide/navi_pic4@2x.jpg" alt="" width="550px" height="420px">
</div>